import PublicTable from './PublicTable'
export default PublicTable
